import { render, staticRenderFns } from "./ShippingSearchForm.vue?vue&type=template&id=95b3bd92&scoped=true&"
import script from "./ShippingSearchForm.vue?vue&type=script&lang=js&"
export * from "./ShippingSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSearchForm.vue?vue&type=style&index=0&id=95b3bd92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3bd92",
  null
  
)

export default component.exports